import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function hexToHSL(hex: string): string | undefined {
  if (!hex) return undefined;
  // Remove hash if present
  hex = hex.replace(/^#/, '');
  
  // Parse hex
  const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return undefined;

  const r = parseInt(result[1], 16) / 255;
  const g = parseInt(result[2], 16) / 255;
  const b = parseInt(result[3], 16) / 255;

  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  h = Math.round(h * 360);
  s = Math.round(s * 100);
  l = Math.round(l * 100);

  return `${h} ${s}% ${l}%`;
}

export function formatRupiah(amount: number): string {
  const formatted = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
  
  // Ensure space between Rp and number if missing (some browsers output Rp10.000)
  const withSpace = formatted.replace(/^Rp(?=\d)/, 'Rp ');
  
  return withSpace + ',-';
}

export function normalizeApiUrl(url: string | null | undefined): string {
  if (!url) return '';
  try {
    const u = new URL(url);
    // Redirect URL server lama ke API URL aktif berdasarkan environment
    const LEGACY_HOSTS = ["chatbot-api-server-ootm.onrender.com", "chat-widget-zygl.onrender.com"];
    if (LEGACY_HOSTS.includes(u.hostname)) {
      // Gunakan VITE_API_URL dari env (staging atau production), fallback ke api.chatbaze.id
      const activeApiUrl = import.meta.env.VITE_API_URL || 'https://api.chatbaze.id';
      try {
        const activeHost = new URL(activeApiUrl).hostname;
        u.hostname = activeHost;
        u.port = '';
        u.protocol = 'https:';
      } catch {
        u.hostname = 'api.chatbaze.id';
      }
    }
    return u.toString().replace(/\/$/, '');
  } catch {
    return url.replace(/\/$/, '');
  }
}
